import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FlaggedCasesComponent } from './flagged-cases/flagged-cases.component';
import { CategorizedNotesListComponent } from './categorized-notes-list/categorized-notes-list.component';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
  imports: [CommonModule, TranslateModule, FlaggedCasesComponent, CategorizedNotesListComponent]
})
export class CasesComponent implements OnInit {
  resume: { flagged?: any; tasks?: any; newCaseInfo?: any };

  ngOnInit(): void {
    this.resume = history.state.resume as unknown;
  }
}

